import { configureStore, combineReducers } from '@reduxjs/toolkit'
import {
  persistReducer,
  createMigrate,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import workflowReducer from '@/reducers/workflow'
import societyInformationsReducer from '@/reducers/societyInformations'
import paymentInformationsReducer from '@/reducers/paymentInformations'
import marketingInformationReducer from '@/reducers/marketingInformation'
import storage from './storage'
import { migrations } from './migrations'

const persistConfig = {
  key: 'root',
  storage: storage,
  version: 0,
  migrate: createMigrate(migrations)
}

const rootReducer = combineReducers({
  workflow: workflowReducer,
  societyInformations: societyInformationsReducer,
  paymentInformations: paymentInformationsReducer,
  marketingInformation: marketingInformationReducer
})

export const persistedReducer = persistReducer(persistConfig, rootReducer)
export const setupStore = (preloadedState?: RootState) => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
      }),
    preloadedState
  })
}

export type RootState = ReturnType<typeof persistedReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
